/**
 * index.js
 *
 * @Author: Wangyinan
 * @Date: 2019/1/7 下午3:58
 */

import Select from './Select';

export default Select;



// WEBPACK FOOTER //
// ./src/select/index.js